import { createSlice } from "@reduxjs/toolkit";

const islogin = () => {
  let login = localStorage.getItem("ACCESS_TOKEN");
  if (login === null) {
    return false;
  } else {
    return true;
  }
};

// Safely parse USER_DATA to prevent invalid JSON errors
const getUserInfo = () => {
  const userData = localStorage.getItem("USER_DATA");
  if (userData) {
    try {
      return userData; // Return as string to match original format
    } catch (e) {
      console.error("Failed to parse USER_DATA:", e);
      return "[]";
    }
  }
  return "[]";
};

const initialState = {
  isLogin: localStorage.getItem("isLogin") === "true" || false,
  token: localStorage.getItem("ACCESS_TOKEN") || null,
  userInfo: getUserInfo(),
};

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setLoginInfo(state, action) {
      const info = action.payload;
      localStorage.setItem("USER_DATA", JSON.stringify(info.userInfo || []));
      localStorage.setItem("isLogin", "true");
      localStorage.setItem("ACCESS_TOKEN", info.token || "");
      state.userInfo = JSON.stringify(info.userInfo || []);
      state.token = info.token || null;
      state.isLogin = true;
    },

    logout(state) {
      localStorage.removeItem("ACCESS_TOKEN");
      localStorage.removeItem("USER_DATA");
      localStorage.removeItem("isLogin");
      localStorage.removeItem("credentials");
      state.token = null;
      state.userInfo = "[]";
      state.isLogin = false;
    },

    // Sync state with localStorage changes
    syncLocalStorage(state) {
      state.isLogin = localStorage.getItem("isLogin") === "true" || false;
      state.token = localStorage.getItem("ACCESS_TOKEN") || null;
      state.userInfo = getUserInfo();
    },
  },
});

// Initialize listener for localStorage changes
export const initLocalStorageSync = (store) => {
  window.addEventListener("localStorageChange", () => {
    store.dispatch(userAction.syncLocalStorage());
  });

  // Cross-tab updates
  window.addEventListener("storage", (event) => {
    if (
      event.key === "ACCESS_TOKEN" ||
      event.key === "USER_DATA" ||
      event.key === "isLogin"
    ) {
      store.dispatch(userAction.syncLocalStorage());
    }
  });
};

// Utility to update localStorage safely
export const updateLocalStorage = (key, value) => {
  if (key === "USER_DATA") {
    // Always stringify objects for USER_DATA
    localStorage.setItem(key, JSON.stringify(value || []));
  } else {
    localStorage.setItem(key, value || "");
  }
  // Trigger custom event for same-tab sync
  window.dispatchEvent(new Event("localStorageChange"));
};

export const userAction = userSlice.actions;
export default userSlice.reducer;
